import React from 'react';
import styles from './css/SearchCTA.styl';
import CTABlock from '../CTABlock';
import appConfig from '../../../../../appConfig/AppConfig';

const data = {
  title: 'Search Obituaries',
  blurb: 'Search more than 1,500 newspapers and 3,500 funeral homes.',
  button: {
    text: 'Search',
    href: `${appConfig().vanityDomain}/search`,
    class: 'ObitsButton',
  },
};

const SearchCTA = () => (
  <div className={styles.SearchCTA}>
    <CTABlock blurb={data.blurb} button={data.button} title={data.title} />
  </div>
);

export default SearchCTA;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/SearchCTA/index.js